<template>
	<div style="width: 100%;height: 100%;">
		<div style="display: flex;flex-direction: column;">
			<div class="con">
				<el-checkbox v-model="checked" @change="changeNum">勾选后进行规则匹配：</el-checkbox>
			</div>
			<div class="item_font" style="width: 37%;">
				<div class="title">只自动分配包含以下区域（用空格隔开）</div>
				<div>
					<el-input v-if="inputShow === true" type="textarea" cols="2" rows="6"  @change="changeNum" placeholder="请输入内容" v-model="tt1" class="item_font"></el-input>
					<el-input v-if="inputShow === false" type="textarea" cols="2" rows="6"  @change="changeNum" placeholder="请输入内容" v-model="tt1" disabled class="item_font"></el-input>
				</div>
			</div>
			<div class="item_font" style="width: 37%;">
				<div class="title">从不自动分配包含以下区域（用空格隔开）</div>
				<div>
					<el-input v-if="inputShow === true" type="textarea" cols="2" rows="6"  @change="changeNum" placeholder="请输入内容" v-model="tt2" class="item_font"></el-input>
					<el-input v-if="inputShow === false" type="textarea" cols="2" rows="6"  @change="changeNum" placeholder="请输入内容" v-model="tt2" disabled class="item_font"></el-input>
				</div>
			</div>
		</div>
		<div style="width: 160px; margin: 0 auto;margin-top: 60px;">
			<!-- <el-button >取消</el-button> -->
			<el-button type="primary" @click="save" class="item_font">保存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TalkPart',
	props: ['userLst', 'item2', 'text1', 'text2', 'check'],
	data() {
		return {
			textarea1: '',
			textarea2: '',
			user: false,
			value: '请选择客服',
			item: '',
			name: '',
			checked: this.check,
			tt1: this.text1,
			tt2: this.text2,
			inputShow: this.check
		};
	},
	mounted() {
		this.index = this.currentIndex;
		console.log("this.texxxxt1",this.text1,'this.texxxt2',this.text2)
	},
	watch: {
		text1: function(newVal, oldVal) {
			console.log(22222,newVal, oldVal);
			this.tt1 = newVal;
		},
		text2: function(newVal, oldVal) {
			console.log(33333,newVal, oldVal);
			
			this.tt2 = newVal;
		},
		check: function(newVal, oldVal) {
			console.log(newVal, oldVal);
			this.checked = newVal;
		},
		currentIndex: function(newVal, oldVal) {
			console.log('currentIndex',newVal, oldVal);
			
			this.index = newVal;
		},
		checked: function(newVal) {
			console.log('checked', newVal);
			this.inputShow = newVal;
		},
		tt1: function() {
			
			this.changeNum()
		},
		item2: function(){
			console.log("item2===========",this.item2)
			this.tt1 = this.item2.text1
			this.tt2 = this.item2.text2
		}
	},
	methods: {
		cellStyle1() {
			return 'text-align:left;height:20px;line-height:20px';
		},
		selsecUser() {
			this.user = true;
		},
		checkUser(row) {
			console.log('*** checkUser ***', row);
			// console.log("@@@ checkHistory @@@",column.label)
			// console.log("### checkHistory ###",event)
			this.value = row.realName;
			this.item = row;
			this.user = false;
			this.$emit('checkUser', {
				tableName: 'part',
				item: this.item,
				currentIndex: row.index
			});
		},
		querySearch(queryString, cb) {
			var userLst = this.userLst;
			var results = queryString ? userLst.filter(this.createFilter(queryString)) : userLst;
			console.log('查询结果', queryString, results);
			if (results.length == 0) {
				results = [{ realName: '未搜索到数据' }];
			}
			this.$emit('restart', {
				tableName: 'part'
			});
			cb(results);
		},
		createFilter(queryString) {
			return data => {
				return data.realName.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
			};
		},
		handleSelect(item) {
			console.log(item);
			this.name = item.realName;
			this.$emit('search', {
				tableName: 'part',
				item: item
			});
		},
		inputNothing(val) {
			console.log('输入值发生改变', val);
			if (val == '') {
				this.$emit('restart', {
					tableName: 'part'
				});
			}
		},
		save() {
			var str1 = this.tt1;
			var str2 = this.tt2;
			// if(str1.replace(/\s+/g,"")==="" ){
			// 	console.log("wei kong")
			// }
			var arr1 = str1.split(' ');
			var arr2 = str2.split(' ');
			console.log('保存区域规则设置', arr1, arr2);
			this.$emit('save', {
				tableName: 'part',
				item: this.item2,
				check: this.checked,
				arr1: arr1,
				arr2: arr2,
				text1:str1,
				text2:str2
			});
		},
    changeNum(){
      var str1 = this.tt1;
      var str2 = this.tt2;
      var arr1 = str1.split(' ');
      var arr2 = str2.split(' ');
      console.log('区域规则设置', arr1, arr2);
      this.$emit('changeNum', {
        tableName: 'part',
        item: {
          text1:str1,
          text2:str2,
          check: this.checked,
        },
        check: this.checked,
        arr1: arr1,
        arr2: arr2,
        text1:str1,
        text2:str2
      });
    },
	}
};
</script>

<style lang="scss">
.con {
	margin-bottom: 20px;
	font-size: 14px;
	@include change_size($font_size_normal)
}

.title {
	margin-bottom: 10px;
	margin-top: 20px;
	font-size: 14px;
	text-align: left;
	white-space: nowrap;
}
.el-textarea{
	@include change_size($font_size_normal)
}
.el-checkbox__label{
		@include change_size($font_size_normal)
	}
</style>
